import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = { class: "bridge" }
const _hoisted_2 = { class: "bridge-header w-full flex justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2" }, "Bridge Back Funds", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close",
  class: "h-4 ml-2 opacity-70"
}, null, -1)
const _hoisted_5 = { class: "bridge-main w-full inline-flex items-center" }
const _hoisted_6 = { class: "stepper__wrapper" }
const _hoisted_7 = { class: "w-full flex flex-col items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_timeline_item = _resolveComponent("n-timeline-item")!
  const _component_n_timeline = _resolveComponent("n-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_nomad_button, {
        disabled: _ctx.sending,
        class: _normalizeClass({ 'cursor-not-allowed opacity-70': _ctx.sending }),
        onClick: _ctx.exit
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Exit "),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "class", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_n_timeline, { class: "custom w-[160px] ml-5 hidden sm:block" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps.slice(0, 5), (step, index) => {
            return (_openBlock(), _createBlock(_component_n_timeline_item, {
              class: _normalizeClass(["capitalize", {
            'active-circle': _ctx.currentStep >= index,
            'active-line': _ctx.currentStep > index,
          }]),
              key: step.title,
              title: step.title,
              content: _ctx.getSubtitle(index)
            }, null, 8, ["title", "content", "class"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_Transition, {
            name: _ctx.transitionType,
            mode: "out-in",
            appear: "",
            class: "mt-6 mb-4 w-full"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.steps[_ctx.currentStep].component), {
                onNext: _ctx.nextStep,
                onBack: _ctx.prevStep
              }, null, 40, ["onNext", "onBack"]))
            ]),
            _: 1
          }, 8, ["name"])
        ])
      ])
    ])
  ]))
}